import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import { useStore } from '@/components/common/store';
import { formatPrice } from '@/js/utils/priceUtils';
import { computed } from 'vue';
import { scrollToHashWithDynamicOffset } from '@utils/utils';
import { getTotalPrice } from '@/js/utils/priceUtils';
import { getDefaultCurrency } from '@utils/environmentUtils';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

type Props = {
	visible?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'StickyOfferButton',
  props: {
    visible: { type: Boolean }
  },
  setup(__props: any) {

const store = useStore();
const { isSmallMobile } = storeToRefs(useBreakpointStore());

const props = __props;
const bestOffer = computed(() => store.state.bestOffer);
const totalPrice = computed(() => formatPrice(getTotalPrice(bestOffer.value?.Pricing ?? {}), getDefaultCurrency()));

const handleClick = () => {
	scrollToHashWithDynamicOffset('offers', false);
};

return (_ctx: any,_cache: any) => {
  return (_unref(isSmallMobile))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["sticky-offer-button", { 'sticky-offer-button--visible': props.visible }])
      }, [
        _createVNode(RoundedButton, {
          class: "sticky-offer-button__button",
          theme: "extra",
          onClick: handleClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Angebote ab " + _toDisplayString(totalPrice.value), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

})